import { SiNextdotjs, SiTailwindcss, SiSupabase, SiPrisma, SiCplusplus, SiArduino, SiPython, SiNodedotjs, SiReact, SiGit, SiUnity, SiBlender, SiHtml5, SiCss3, SiJavascript, SiTypescript, SiPostgresql, SiOracle, SiFigma, SiAndroidstudio } from 'react-icons/si';
import { FaJava } from 'react-icons/fa';

export const profileData = {
  info: {
    name: "Carlos Alberto Mariscal Romo", 
    role: "Computer Engineering Student & Full Stack Dev", 
    email: "cmariscal102@gmail.com",
    github: "MCarlos7",
    linkedin: "mcarlos7", 
    cvLink: "/CV_CarlosMariscal.pdf",
    location: "Guadalajara, México" 
  },
  about: {
    title: "Professional Profile",
    description: "Computer Engineering student passionate about software development. Solid knowledge in full-stack development (React, Node.js), Data Science (Pandas, Scikit-learn), and Python programming. Also interested in video game development with Unity.",
    subText: "Seeking an internship, trainee or Junior Developer position to apply my problem-solving skills and contribute to challenging projects."
  },
  education: [ 
    {
      institution: "University Center for Exact Sciences and Engineering (CUCEI)",
      degree: "Computer Engineering",
      period: "Expected completion: Dec 2026",
      details: "Relevant Coursework: Machine Learning, Video Game Development, Software Engineering, Databases."
    }
  ],
  certifications: [ 
    {
      name: "Learn, Connect, Transform: Databases with Oracle",
      issuer: "Oracle Volunteering",
      date: "Expected: April 2026"
    }
  ],
  skills: [
    { name: 'Python', icon: <SiPython size={40} className="text-warning" /> },
    { name: 'JavaScript', icon: <SiJavascript size={40} className="text-warning" /> },
    { name: 'TypeScript', icon: <SiTypescript size={40} className="text-primary" /> },
    { name: 'C++', icon: <SiCplusplus size={40} className="text-primary" /> },
    { name: 'Java', icon: <FaJava size={40} className="text-danger" /> },
    
    { name: 'React', icon: <SiReact size={40} className="text-info" /> },
    { name: 'Next.js', icon: <SiNextdotjs size={40} className="text-dark" /> },
    { name: 'Tailwind', icon: <SiTailwindcss size={40} className="text-info" /> },
    { name: 'Node.js', icon: <SiNodedotjs size={40} className="text-success" /> },
    
    { name: 'Supabase', icon: <SiSupabase size={40} className="text-success" /> },
    { name: 'PostgreSQL', icon: <SiPostgresql size={40} className="text-primary" /> },
    { name: 'Oracle', icon: <SiOracle size={40} className="text-danger" /> },
    { name: 'Unity', icon: <SiUnity size={40} className="text-dark" /> }, // [cite: 38]
    { name: 'Blender', icon: <SiBlender size={40} className="text-warning" /> },
    { name: 'Git', icon: <SiGit size={40} className="text-danger" /> },
  ],
  github: {
    username: "MCarlos7",
    priorityRepos: ['Anfitrion', 'COMPILER', 'ARM-VR', 'EnergIA'] 
  }
};